import {Observable} from 'rxjs';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest} from '@angular/common/http';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import { countryConfig } from 'src/country-config/country-config';
import { DeliveryTypeEnum } from '../../networking/models/location/enum/delivery-type.enum';
import { LocalStorageManager } from '../../manager/local-storage/local-storage.manager';
import { isPlatformBrowser } from '@angular/common';

const urls = [
  '/v2/api/home',
  '/v2/api/department',
  '/v2/api/offers/flash',
  '/v2/api/offers/suggest',
  '/v2/api/offers/highlights',
  '/v2/api/banners/main',
  '/v2/api/banners/min-left',
  '/v2/api/banners/left-advertising',
  '/v2/api/banners/right-advertising',
  '/v2/api/customer/item/purchase',
  '/v2/api/customer/item/recently-view',
  '/talon-one/customer-session/v2/getDiscounts',
  '/api/customer/item/favorite',
  '/api/productEndpoint/v2/getItem',
  '/api/orderEndpoint/v2/createOrder',
  '/api/orderEndpoint/v2/priceDeliveryOrder',
  '/api/orderEndpoint/priceDeliveryOrderAgile',
  '/api/customerEndpoint/landingPages',
  '/api/customerEndpoint/customer/favorite',
  '/api/categoryEndpoint/getMostSales',
]

@Injectable({
  providedIn: 'root',
})
export class TalonParamsInterceptor implements HttpInterceptor {
  isBrowser: boolean;

  constructor(private localStorageManager: LocalStorageManager, @Inject(PLATFORM_ID) platformId,) {
     this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
   }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const allowUrl = urls.find((url: string) => request.url.includes(url));
    const sourceType = window.innerWidth < 992 ? 'RESPONSIVE' : 'WEB';
    const finalSourceType = this.isBrowser ? sourceType : 'WEB';
    

    if (allowUrl) {
      const address = this.localStorageManager.get('deliveryAddress');
      let talonOneData = {
        deliveryType: address?.deliveryType || DeliveryTypeEnum.EXPRESS,
        storeId: address?.defaultStore || countryConfig.defaultStoreId,
        city: address?.city || countryConfig.defaultCity
      };
      let requestWithData = null;
      if (request.method === 'GET') {
        const queryParams = new HttpParams({ fromObject: talonOneData });
        requestWithData = { params: queryParams };
      } else {
        requestWithData = { body: request.body };
        const copyTalonOneData = requestWithData.body.talonOneData;
        requestWithData.body.talonOneData = { ...copyTalonOneData, ...talonOneData, source: finalSourceType };
      }
      const newRequest = request.clone(requestWithData);
      return next.handle(newRequest);
    }
    return next.handle(request);
  }
}